import { render, staticRenderFns } from "./AppBar.vue?vue&type=template&id=4585c052&scoped=true"
import script from "./AppBar.vue?vue&type=script&lang=js"
export * from "./AppBar.vue?vue&type=script&lang=js"
import style0 from "./AppBar.vue?vue&type=style&index=0&id=4585c052&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4585c052",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4585c052')) {
      api.createRecord('4585c052', component.options)
    } else {
      api.reload('4585c052', component.options)
    }
    module.hot.accept("./AppBar.vue?vue&type=template&id=4585c052&scoped=true", function () {
      api.rerender('4585c052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/core/AppBar.vue"
export default component.exports